<div ngbDropdown class="d-inline-block" placement="bottom-end">
  <button
    type="button"
    id="fy-selection"
    class="btn btn-outline"
    ngbDropdownToggle
  >
    <i-lucide name="calendar"></i-lucide>
    @if (selectedFinancialYear) {
      {{ selectedFinancialYear | aafinyear }}
    } @else {
      <em>(Loading fiscal years&hellip;)</em>
    }
  </button>
  <div
    ngbDropdownMenu
    class="date-range-selector"
    aria-labelledby="calendar-selection"
  >
    <h5>Financial Years</h5>
    <div class="dropdown-row">
      @for (finYear of yearNavs; track $index) {
        <button
          type="button"
          ngbDropdownItem
          class="btn btn-outline-dark btn-calendar"
          [class.active-item]="
            finYear.startDate === selectedFinancialYear?.startDate &&
            finYear.endDate === selectedFinancialYear?.endDate
          "
          [disabled]="!finYear.isSelectionAvailable"
          (click)="onUserChangedFinancialYear(finYear)"
        >
          <div class="item-icon">
            @if (finYear.gridIcon) {
              @for (dot of finYear.gridIcon; track $index) {
                <span class="dot" [class.dot-active]="dot"></span>
              }
            }

            @if (finYear.icon) {
              <i-lucide name="{{ finYear.icon }}" class="giant-icon"></i-lucide>
            }
          </div>
          <div
            [innerText]="
              finYear.startDate | aadaterange: finYear.endDate : true
            "
            class="date"
          ></div>
          <div [innerText]="finYear.name" class="name"></div>
        </button>
      }
    </div>
  </div>
</div>
